<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormMzip_Articulo" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ARTICULO_ID">ARTICULO_ID</label>
							<input type="text" v-model="objMzip_Articulo.ARTICULO_ID" class="form-control" id="ARTICULO_ID" placeholder="Ingresar ARTICULO_ID" />
							<CValidation v-if="this.errorvalidacion.ARTICULO_ID" :Mensaje="'*'+errorvalidacion.ARTICULO_ID[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="LINEA_ARTICULO_ID">LINEA_ARTICULO_ID</label>
							<input type="text" v-model="objMzip_Articulo.LINEA_ARTICULO_ID" class="form-control" id="LINEA_ARTICULO_ID" placeholder="Ingresar LINEA_ARTICULO_ID" />
							<CValidation v-if="this.errorvalidacion.LINEA_ARTICULO_ID" :Mensaje="'*'+errorvalidacion.LINEA_ARTICULO_ID[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="CLAVE_ARTICULO">CLAVE_ARTICULO</label>
							<input type="text" v-model="objMzip_Articulo.CLAVE_ARTICULO" class="form-control" id="CLAVE_ARTICULO" placeholder="Ingresar CLAVE_ARTICULO" />
							<CValidation v-if="this.errorvalidacion.CLAVE_ARTICULO" :Mensaje="'*'+errorvalidacion.CLAVE_ARTICULO[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objMzip_Articulo.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Precio">Precio</label>
							<input type="text" v-model="objMzip_Articulo.Precio" class="form-control" id="Precio" placeholder="Ingresar Precio" />
							<CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Estatus">Estatus</label>
							<input type="text" v-model="objMzip_Articulo.Estatus" class="form-control" id="Estatus" placeholder="Ingresar Estatus" />
							<CValidation v-if="this.errorvalidacion.Estatus" :Mensaje="'*'+errorvalidacion.Estatus[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="EstatusAnterior">EstatusAnterior</label>
							<input type="text" v-model="objMzip_Articulo.EstatusAnterior" class="form-control" id="EstatusAnterior" placeholder="Ingresar EstatusAnterior" />
							<CValidation v-if="this.errorvalidacion.EstatusAnterior" :Mensaje="'*'+errorvalidacion.EstatusAnterior[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="UltimaSincro">UltimaSincro</label>
							<input type="text" v-model="objMzip_Articulo.UltimaSincro" class="form-control" id="UltimaSincro" placeholder="Ingresar UltimaSincro" />
							<CValidation v-if="this.errorvalidacion.UltimaSincro" :Mensaje="'*'+errorvalidacion.UltimaSincro[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Sincronizado">Sincronizado</label>
							<input type="text" v-model="objMzip_Articulo.Sincronizado" class="form-control" id="Sincronizado" placeholder="Ingresar Sincronizado" />
							<CValidation v-if="this.errorvalidacion.Sincronizado" :Mensaje="'*'+errorvalidacion.Sincronizado[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormMzipArticulo',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objMzip_Articulo: {
				IdArticulo: 0,
				ARTICULO_ID: '',
				LINEA_ARTICULO_ID: '',
				CLAVE_ARTICULO: '',
				Nombre: '',
				Precio: '',
				Estatus: '',
				EstatusAnterior: '',
				UltimaSincro: '',
				Sincronizado: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objMzip_Articulo.IdArticulo == 0) {
				await this.$http.post(
					'articulos',this.objMzip_Articulo
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'articulos/'+this.objMzip_Articulo.IdArticulo,
					this.objMzip_Articulo
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "articulos/"+this.objMzip_Articulo.IdArticulo
            ).then((res) => {
                this.objMzip_Articulo = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objMzip_Articulo.Fecha.replace(/-/g,'\/');
                this.objMzip_Articulo.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objMzip_Articulo = {
				IdArticulo: 0,
				ARTICULO_ID: '',
				LINEA_ARTICULO_ID: '',
				CLAVE_ARTICULO: '',
				Nombre: '',
				Precio: '',
				Estatus: '',
				EstatusAnterior: '',
				UltimaSincro: '',
				Sincronizado: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objMzip_Articulo.IdArticulo = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
